import React, { useEffect, useRef } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { debugZodResolver } from '@/lib/debugZodResolver';
import ActionButton from '@/components/buttons/ActionButton.tsx';
import {
  userDetailsSchema,
  type UserDetailsFormData,
} from '../schemas/completeProfileSchemas';
import { useCompleteProfile } from '../contexts/CompleteProfileContext';
import AuthFormContainer from '@/features/auth/signup/components/AuthFormContainer.tsx';
import { TextInput } from '@/components/form/TextInput.tsx';
import CacPhoneInput from '@/components/form/CacPhoneInput.tsx';
import { useNavigate } from '@tanstack/react-router';
import { toast } from 'sonner';
import { completeProfileRoute } from '@/features/auth/signup/routes/completeProfileRoutes.ts';

const CompleteUserDetailsPage = () => {
  const navigate = useNavigate();
  const { verificationSuccess, newCompany } = completeProfileRoute.useSearch();
  const toastShown = useRef(false);

  useEffect(() => {
    if (verificationSuccess && !toastShown.current) {
      toastShown.current = true;
      toast.success('Adres email został pomyślnie zweryfikowany');
    }
  }, [verificationSuccess]);
  const { updateUserDetails } = useCompleteProfile();

  const methods = useForm<UserDetailsFormData>({
    resolver: debugZodResolver(userDetailsSchema),
  });
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = methods;
  const onSubmit = (data: UserDetailsFormData) => {
    updateUserDetails({
      name: data.name,
      surname: data.surname,
      phoneNumber: data.phoneNumber,
    });
    // Bez `newCompany` strażnik trasy odesłałby właściciela istniejącej firmy do /app.
    navigate({ to: '/auth/complete-profile/company', search: { newCompany } });
  };

  return (
    <FormProvider {...methods}>
      <AuthFormContainer title="Uzupełnij swoje dane">
        <form
          onSubmit={handleSubmit(onSubmit)}
          noValidate
          className="w-full space-y-6"
        >
          <TextInput
            label="Imię"
            register={register('name')}
            placeholder="Wprowadź swoje imię"
            required={true}
            error={errors.name?.message}
          />
          <TextInput
            label="Nazwisko"
            register={register('surname')}
            placeholder="Wprowadź swoje nazwisko"
            required={true}
            error={errors.surname?.message}
          />
          <CacPhoneInput
            fieldPath="phoneNumber"
            error={errors.phoneNumber?.message}
          />
          <ActionButton type="submit" tone="accent" size="block">
            Dalej
          </ActionButton>
        </form>
      </AuthFormContainer>
    </FormProvider>
  );
};

export default CompleteUserDetailsPage;
